<template>
  <div class="companyAuth">
    <div class="form-item">
      <label class="label"><i class="required">*</i>营业执照</label>
      <div class="input-box">
        <div class="card-wrapper">
          <uploader @success="uploadLicense" id="license" accept="*.jpg;*.gif;*.png;">
            <i class="card-file">上传</i>
            <img v-if="form.BusinessLicenseImgPath" :src="form.BusinessLicenseImgPath" alt="" class="file-img">
          </uploader>
        </div>
      </div>
    </div>
    <div class="form-item">
      <label class="label"><i class="required">*</i>企业名称</label>
      <div class="input-box">
        <input class="input" v-model.trim="form.CompanyName" type="text" placeholder="营业执照的注册名称">
      </div>
    </div>
    <div class="form-item">
      <label class="label"><i class="required">*</i>企业类型</label>
      <div class="input-box">
        <input class="input" v-model.trim="form.BusLicenseCompanyType" type="text" placeholder="工商注册公司类型">
      </div>
    </div>
    <div class="form-item">
      <label class="label"><i class="required">*</i>类型</label>
      <div class="input-box">
        <el-select v-model="form.TianWeiYunCompanyType" placeholder="请选择类型" :disabled="isDisable" @change="changeType">
          <el-option v-for="item in types" :key="item.value"  :value="item.value" :label="item.label" value-key="value"></el-option>
        </el-select>
      </div>
    </div>
    <div class="form-item">
      <label class="label"><i class="required">*</i>法人代表</label>
      <div class="input-box">
        <input class="input" v-model.trim="form.LegalPerson" type="text" placeholder="工商注册法人姓名">
      </div>
    </div>
    <div class="form-item">
      <label class="label"><i class="required">*</i>注册资本</label>
      <div class="input-box">
        <input class="input" v-model.trim="form.RegisteredCapital" type="text" placeholder="注册资本">
      </div>
    </div>
    <div class="form-item">
      <label class="label"><i class="required">*</i>成立日期</label>
      <div class="input-box">
        <input class="input" v-model.trim="form.EstablishmentDate" type="text" :readonly="isDisable" placeholder="成立日期">
      </div>
    </div>
    <div class="form-item">
      <label class="label"><i class="required">*</i>营业期限</label>
      <div class="input-box">
        <input class="input" v-model.trim="form.BusinessTerm" type="text" :readonly="isDisable" placeholder="营业期限">
      </div>
    </div>
    <div class="form-item">
      <label class="label"><i class="required">*</i>地址</label>
      <div class="input-box">
        <input class="input" v-model.trim="form.RegisterAddress" type="text" placeholder="地址">
      </div>
    </div>
    <div class="form-item">
      <label class="label"><i class="required">*</i>营业执照编号</label>
      <div class="input-box">
        <input class="input" autocomplete="off" v-model.trim="form.BusinessLicense" type="text" placeholder="三证合一的企业纳税识别号">
      </div>
    </div>
    <div class="form-item">
      <span class="label"></span>
      <div class="input-box">
        <button class="btn-primary" @click="submit">下一步</button>
      </div>
    </div>
  </div>
</template>
<script>
import uploader from '@/components/uploader.vue'
import {scanLicense,AddErrorLog,RealNameEnterpriseAuth} from '@/scripts/api.js'
import Bus from '@/scripts/bus.js'
export default {
  components:{
    uploader
  },
  data(){
    return{
      form:{
        BusinessLicenseImgPath:'',
        CompanyName:'',
        BusinessLicense:'',
        BusLicenseCompanyType:'',
        TianWeiYunCompanyType:'',
        EstablishmentDate:'',
        BusinessTerm:'',
        LegalPerson:'',
        RegisteredCapital:'',
        RegisterAddress:'',
      },
      licenseData:null,
      types:[
        {
          label:'企业（ET_PE）',
          value:'ET_PE',
        },
        {
          label:'个体工商户（ET_SE）',
          value:'ET_SE',
        },
        {
          label:'政府机构/事业单位（ET_OU）',
          value:'ET_OU',
        }
      ],
      IsValidPerson:false,
    }
  },
  computed: {
    isDisable(){
      if(this.form.BusinessLicenseImgPath=='' && !this.IsValidPerson){
        return true;
      }
      return false;
    }
  },
  methods: {
    //上传营业执照
    uploadLicense(file,res){
      this.form.BusinessLicenseImgPath=res[0].imgUrl;
      scanLicense({
        AI_BUSINESS_LICENSE_IMAGE:this.form.BusinessLicenseImgPath,
        AI_BUSINESS_LICENSE_IMAGE_TYPE:'1',
      }).then(r=>{
        this.licenseData={...r};
        this.form.CompanyName=r.ENTERPRISE_NAME_CH;
        this.form.BusLicenseCompanyType=r.ENTERPRISE_TYPE;
        this.form.EstablishmentDate=r.ENTERPRISE_TIME;
        this.form.LegalPerson=r.ENTERPRISE_OWNER;
        this.form.RegisteredCapital=r.ENTERPRISE_CAPITAL;
        this.form.RegisterAddress=r.ENTERPRISE_REGISTER_ADDRESS;
        this.form.BusinessLicense=r.ENTERPRISE_ID;
        if(r.ENTERPRISE_VALID_DATE_START && r.ENTERPRISE_VALID_DATE_END){
          this.form.BusinessTerm=r.ENTERPRISE_VALID_DATE_START+'至'+r.ENTERPRISE_VALID_DATE_END;
        }
        if(r.ENTERPRISE_VALID_DATE_START){
          this.form.BusinessTerm=r.ENTERPRISE_VALID_DATE_START;
        }
        if(r.ENTERPRISE_VALID_DATE_END){
          this.form.BusinessTerm=r.ENTERPRISE_VALID_DATE_END;
        }
        this.form.TianWeiYunCompanyType=this.types[0].value;
      })
    },
    changeType(){
      if((this.form.TianWeiYunCompanyType=='ET_PE' || this.form.TianWeiYunCompanyType=='ET_SE') && this.licenseData){
        this.form.BusinessLicense=this.licenseData.ENTERPRISE_ID;
      }
      if(this.form.TianWeiYunCompanyType=='ET_OU' && this.licenseData){
        this.form.BusinessLicense=this.licenseData.ENTERPRISE_ID || this.licenseData.ENTERPRISE_UNIVERSAL_CREDIT_ID_AGENCY_CODE;
      }
    },
    submit(){
      if(this.form.BusinessLicenseImgPath==''){
        this.$toast('请上传营业执照');
        AddErrorLog('/RealNameEnterpriseAuth','请上传营业执照');
        return;
      }
      if(this.form.CompanyName==''){
        this.$toast('请输入企业名称');
        AddErrorLog('/RealNameEnterpriseAuth','请输入企业名称');
        return;
      }
      if(this.form.BusLicenseCompanyType==''){
        this.$toast('请输入公司类型');
        AddErrorLog('/RealNameEnterpriseAuth','请输入公司类型');
        return;
      }
      if(this.form.TianWeiYunCompanyType==''){
        this.$toast('请选择类型');
        AddErrorLog('/RealNameEnterpriseAuth','请选择类型');
        return;
      }
      if(this.form.LegalPerson==''){
        this.$toast('请输入企业法人代表');
        AddErrorLog('/RealNameEnterpriseAuth','请输入企业法人代表');
        return;
      }
      if(this.form.RegisteredCapital==''){
        this.$toast('请输入注册资本');
        AddErrorLog('/RealNameEnterpriseAuth','请输入注册资本');
        return;
      }
      if(this.form.EstablishmentDate==''){
        this.$toast('请输入企业成立日期');
        AddErrorLog('/RealNameEnterpriseAuth','请输入企业成立日期');
        return;
      }
      if(this.form.BusinessTerm==''){
        this.$toast('请输入企业营业期限');
        AddErrorLog('/RealNameEnterpriseAuth','请输入企业营业期限');
        return;
      }
      if(this.form.RegisterAddress==''){
        this.$toast('请输入企业注册地址');
        AddErrorLog('/RealNameEnterpriseAuth','请输入企业注册地址');
        return;
      }
      if(this.form.BusinessLicense==''){
        this.$toast('请输入营业执照编号');
        AddErrorLog('/RealNameEnterpriseAuth','请输入营业执照编号');
        return;
      }
      let params={
        ...this.form,
        IsValidPerson:this.IsValidPerson,
        // UserCode:this.userInfo.UserCode,
        platform:'pcweb'
      }
      RealNameEnterpriseAuth(params).then(r=>{
        if(r.Result==1){
          // this.IsValidPerson=!this.IsValidPerson;
          this.$emit('stepChange',1);
          Bus.$emit('toCompanyRegister2',params);
        }else{
          this.$toast(r.Message);
        }
      })
    },
  },
}
</script>
<style lang="scss">
.companyAuth{
  .card-wrapper{
    overflow: hidden;
    width: 580px;
    margin-bottom: 10px;
    .file-uploader{
      float: left;
      width: 270px;
      height: 165px;
      margin-right: 15px;
    }
  }
    .file-img{
      position: absolute;
      left: 0;
      top: 0;
      width: 100%;
      height: 100%;
    }
    .card-file {
      display:inline-block;
      position: relative;
      width: 270px;
      height: 165px;
      background-color: #fff;
      border: 1px solid #e5e5e5;
      cursor:pointer;
      padding-top: 124px;
      font-size: 14px;
      color: #999;
      line-height: 24px;
      text-align: center;
    }

    .card-file:before,
    .card-file:after {
      content: "";
      position: absolute;
      left: 50%;
      top: 50%;
      border-radius: 2px;
      background-color: #e5e5e5;
    }

    .card-file:before {
      width: 60px;
      height: 8px;
      margin-left: -30px;
      margin-top: -4px;
    }

    .card-file:after {
      width: 8px;
      height: 60px;
      margin-top: -30px;
      margin-left: -4px;
    }
    
  .el-select{
    width: 100%;
    *{
      height: 38px;
      line-height: 38px;
    }
    .el-input__inner{
      &:read-only{
        cursor:auto;
        background-color: #fff;
      }
    }
  }
}
</style>